import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ICONS_SVG_SET } from './icon-set.constant';

@Injectable({ providedIn: 'root' })
export class IconsService {
  constructor() {
    const domSanitizer = inject(DomSanitizer);
    const matIconRegistry = inject(MatIconRegistry);

    // Registra todo el set de una sola vez, desde una constante en memoria
    // (sin HTTP request). El <svg id="..."> de cada icono debe coincidir
    // con el `svgIcon` usado en el template, igual que con addSvgIconSet.
    // Como no hay fetch de por medio, funciona igual en SSR sin necesidad
    // de comprobar isPlatformBrowser.
    matIconRegistry.addSvgIconSetLiteral(
      domSanitizer.bypassSecurityTrustHtml(ICONS_SVG_SET)
    );
  }
}
